/* eslint-disable */
import React from 'react';
import './index.less';
import './index.en.less';

export interface IDoDontColumn {
  title?: any;
  items?: string[];
}

export interface IDoDontCardsProps {
  doColumn?: IDoDontColumn;
  dontColumn?: IDoDontColumn;
  id?: string;
}

const renderColumn = (
  column: IDoDontColumn | undefined,
  variant: 'do' | 'dont'
) => {
  if (!column) return null;
  const { title, items = [] } = column;

  return (
    <div className={`do-dont-card do-dont-card--${variant}`}>
      {title && (
        <div className="do-dont-card-heading">
          <span
            className="do-dont-card-heading-text"
            dangerouslySetInnerHTML={{ __html: title }}
          ></span>
        </div>
      )}
      <ul className="do-dont-card-list">
        {items.map((item, index) => (
          <li key={index} className="do-dont-card-item">
            <span className="do-dont-card-item-text">{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

const DoDontCards: React.FunctionComponent<IDoDontCardsProps> = ({
  doColumn,
  dontColumn,
  id,
}) => {
  if (!doColumn && !dontColumn) return null;

  return (
    <div className="do-dont-cards" id={id}>
      {renderColumn(doColumn, 'do')}
      {renderColumn(dontColumn, 'dont')}
    </div>
  );
};

export default React.memo(DoDontCards);
